export default {
  "--color-primary-50": "238 242 255",
  "--color-primary-100": "218 234 255",
  "--color-primary-200": "218 234 255",
  "--color-primary-300": "189 220 255",
  "--color-primary-400": "144 198 255",
  "--color-primary-500": "92 167 254",
  "--color-primary-600": "66 138 251",
  "--color-primary-700": "32 99 240",
  "--color-primary-800": "24 78 221",
  "--color-primary-900": "26 63 179",
  "--color-secondary-50": "249 250 251",
  "--color-secondary-100": "243 244 246",
  "--color-secondary-200": "229 231 235",
  "--color-secondary-300": "209 213 219",
  "--color-secondary-400": "156 163 175",
  "--color-secondary-500": "107 114 128",
  "--color-secondary-600": "75 85 99",
  "--color-secondary-700": "55 65 81",
  "--color-secondary-800": "31 41 55",
  "--color-secondary-900": "17 24 39",
  "--color-default": "255 255 255",
};
